<template>
    <div class="flex flex-col justify-center overflow-hidden bg-green-400 pb-8 lg:pt-40 lg:pb-20">
        <div class="flex flex-col justify-between lg:flex-row">
            <div class="block lg:hidden">
                <div class="flex flex-col !justify-between px-8 pt-16 pb-10 lg:pt-20">
                    <div class="">
                        <h2 class="alt-title mb-2" v-html="title"></h2>
                        <div class="info-sanity-content mb-5 lg:w-[60%]">
                            <SanityContent :blocks="body" :serializers="serializers" />
                        </div>
                    </div>
                    <div v-if="socialMediaIcons" class="flex space-x-4">
                        <nav class="my-8">
                            <ul class="flex items-center">
                                <li>
                                    <NuxtLink class="mr-6 block" target="_blank" :to="siteConfig[0]?.facebook">
                                        <NuxtImg
                                            class="size-5"
                                            src="/social_media/facebook.svg"
                                            sizes="100vw sm:50vw md:400px" />
                                    </NuxtLink>
                                </li>
                                <li>
                                    <NuxtLink class="mr-6 block" target="_blank" :to="siteConfig[0]?.instagram">
                                        <NuxtImg
                                            class="size-5"
                                            src="/social_media/insta.svg"
                                            sizes="100vw sm:50vw md:400px" />
                                    </NuxtLink>
                                </li>
                                <li>
                                    <NuxtLink class="mr-6 block" target="_blank" :to="siteConfig[0]?.tiktok">
                                        <NuxtImg
                                            class="size-5"
                                            src="/social_media/tiktok.svg"
                                            sizes="100vw sm:50vw md:400px" />
                                    </NuxtLink>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            <div class="w-full overflow-hidden">
                <div class="boxed-slider">
                    <div ref="container" class="keen-slider !overflow-visible">
                        <!-- Text slide is only a real slide on desktop; below lg it's rendered by the stacked mobile block above. Keeping it here as a hidden keen slide made keen mis-measure it (phantom ~530px slide → images pushed off-screen on tablet). -->
                        <div
                            v-if="showTextSlide"
                            class="keen-slider__slide number-slide0 hidden lg:block lg:max-w-[430px] lg:min-w-[430px] xl:max-w-[646px] xl:min-w-[646px]">
                            <div class="flex flex-col !justify-between py-20">
                                <div>
                                    <h2 class="alt-title mb-2" v-html="title"></h2>
                                    <div class="info-sanity-content mb-5 w-[70%]">
                                        <SanityContent :blocks="body" :serializers="serializers" />
                                    </div>
                                </div>
                                <div class="flex space-x-4">
                                    <nav v-if="socialMediaIcons">
                                        <ul class="flex items-center">
                                            <li v-if="siteConfig[0].facebook">
                                                <NuxtLink
                                                    class="mr-6 block"
                                                    target="_blank"
                                                    :to="siteConfig[0].facebook">
                                                    <NuxtImg
                                                        class="size-5"
                                                        src="/social_media/facebook.svg"
                                                        sizes="100vw sm:50vw md:400px" />
                                                </NuxtLink>
                                            </li>
                                            <li v-if="siteConfig[0].instagram">
                                                <NuxtLink
                                                    class="mr-6 block"
                                                    target="_blank"
                                                    :to="siteConfig[0].instagram">
                                                    <NuxtImg
                                                        class="size-5"
                                                        src="/social_media/insta.svg"
                                                        sizes="100vw sm:50vw md:400px" />
                                                </NuxtLink>
                                            </li>
                                            <li v-if="siteConfig[0].tiktok">
                                                <NuxtLink class="mr-6 block" target="_blank" :to="siteConfig[0].tiktok">
                                                    <NuxtImg
                                                        class="size-5"
                                                        src="/social_media/tiktok.svg"
                                                        sizes="100vw sm:50vw md:400px" />
                                                </NuxtLink>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <template v-for="(element, index) in elements">
                            <div
                                :class="'keen-slider__slide number-slide' + (index + 1)"
                                class="!flex aspect-[9/10] h-[367px] max-w-[264px] min-w-[264px] items-center md:h-[480px] md:max-w-[345px] md:min-w-[345px] lg:h-[500px] lg:max-w-[445px] lg:min-w-[445px] xl:h-[600px] xl:max-w-[534px] xl:min-w-[534px]">
                                <div
                                    class="h-full w-full max-w-[264px] min-w-[264px] md:max-w-[345px] md:min-w-[345px] lg:max-w-[445px] lg:min-w-[445px] xl:max-w-[534px] xl:min-w-[534px]">
                                    <NuxtLink
                                        class="block h-full"
                                        :to="element?.link?._ref ? getUrlById(element.link._ref) || '#' : '#'">
                                        <div class="group relative h-full overflow-hidden">
                                            <NuxtImg
                                                v-if="element.image"
                                                :src="useImageUrl(element.image).format('webp').width(1200).url()"
                                                class="h-full w-full rounded-sm object-cover"
                                                :alt="element?.image?.alt"
                                                sizes="100vw sm:50vw md:400px"
                                                width="400"
                                                height="500"
                                                placeholder
                                                format="webp"
                                                loading="lazy" />
                                            <div
                                                v-if="!textBelowImage"
                                                class="absolute right-0 bottom-10 left-0 flex flex-col text-center text-white lg:bottom-20">
                                                <p
                                                    class="font-monument-extended text-sm transition-all group-hover:text-green-500 lg:text-lg">
                                                    {{ element?.text }}
                                                </p>
                                                <p
                                                    class="font-mori mx-auto mt-1 w-max border-b-2 text-sm font-semibold transition-all group-hover:border-green-500 group-hover:text-green-500">
                                                    Ontdek meer
                                                </p>
                                            </div>
                                        </div>
                                        <h3 v-if="textBelowImage" class="mt-5 text-lg font-bold">
                                            {{ element?.text }}
                                        </h3>
                                    </NuxtLink>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="normal-container font-mori mt-10 flex items-end justify-end space-x-4 font-normal lg:mt-10 2xl:w-full"
            v-if="elements">
            <div class="flex items-center justify-center space-x-3">
                <button
                    type="button"
                    :aria-label="snippets['headless.slider.prev']"
                    id="info-slider-prev-button"
                    class="mr-0!">
                    <ArrowLeftIcon
                        :class="{
                            'text-[#A09E9A]': current === 0,
                            'logo-slider-prev': true,
                            'cursor-pointer': true,
                        }"
                        class="size-4 stroke-[2px] text-black lg:size-6" />
                </button>
                <div class="mx-2">{{ displayIndex }} / {{ elements?.length }}</div>
                <button type="button" :aria-label="snippets['headless.slider.next']" id="info-slider-next-button">
                    <ArrowRightIcon class="size-4 cursor-pointer stroke-[2px] text-black lg:size-6" />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useKeenSlider } from 'keen-slider/vue';
    import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/vue/24/outline';
    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    const siteConfig = await useSiteSettings();
    const props = defineProps({
        infoSlider: Object,
        title: String,
        text: String,
        button: Object,
        elements: Array,
        showLink: Boolean,
        body: {
            type: [String, Object],
            required: true,
        },
        socialMediaIcons: Boolean,
        textBelowImage: Boolean,
    });

    const navigation = slider => {
        slider.on('created', () => {
            let nextSlideButton = document.getElementById('info-slider-next-button');
            let prevSlideButton = document.getElementById('info-slider-prev-button');

            const next = () => {
                slider.next();
            };

            const prev = () => {
                slider.prev();
            };

            nextSlideButton.addEventListener('click', next);
            prevSlideButton.addEventListener('click', prev);
        });
    };

    const dataLoaded = ref(false);
    onMounted(() => {
        dataLoaded.value = true;
    });

    const UpdateSlider = slider => {
        let touchTimeout;

        const waitForData = setInterval(() => {
            if (dataLoaded.value) {
                clearInterval(waitForData);
                slider.update();
            }
        }, 1000);
    };

    // Horizontal scroll keen slider
    const WheelControls = slider => {
        let touchTimeout;
        let position;
        let wheelActive;

        function dispatch(e, name) {
            position.x -= e.deltaX;
            position.y -= e.deltaY;
            slider.container.dispatchEvent(
                new CustomEvent(name, {
                    detail: {
                        x: position.x,
                        y: position.y,
                    },
                }),
            );
        }

        function wheelStart(e) {
            position = {
                x: e.pageX,
                y: e.pageY,
            };
            dispatch(e, 'ksDragStart');
        }

        function wheel(e) {
            dispatch(e, 'ksDrag');
        }

        function wheelEnd(e) {
            dispatch(e, 'ksDragEnd');
        }

        function eventWheel(e) {
            // Check the scroll direction
            const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

            // Prevent default behavior only for horizontal scroll
            if (isHorizontalScroll) {
                e.preventDefault();
                if (!wheelActive) {
                    wheelStart(e);
                    wheelActive = true;
                }
                wheel(e);
                clearTimeout(touchTimeout);
                touchTimeout = setTimeout(() => {
                    wheelActive = false;
                    wheelEnd(e);
                }, 50);
            }
        }

        slider.on('created', () => {
            slider.container.addEventListener('wheel', eventWheel, {
                passive: false,
            });
        });
    };

    const current = ref(0);

    // Keen slider
    const [container, slider] = useKeenSlider(
        {
            loop: false,
            initial: current.value,
            slideChanged: s => {
                current.value = s.track.details.rel;
            },
            rubberband: false,
            breakpoints: {
                '(min-width: 0px)': {
                    mode: 'free-snap',
                    slides: { perView: 'auto', spacing: 10 },
                },
                '(min-width: 662px)': {
                    mode: 'free-snap',
                    slides: { perView: 'auto', spacing: 10 },
                },
                '(min-width: 1024px)': {
                    mode: 'free-snap',
                    slides: { perView: 'auto', spacing: 40 },
                },
            },
        },
        [WheelControls, navigation, UpdateSlider],
    );

    // Text is a keen slide only on desktop; below lg the stacked mobile block renders it instead.
    // Default true so SSR/first client render match; corrected on mount + on breakpoint change, then re-measure keen.
    const showTextSlide = ref(true);
    // Counter shows the image position (1..elements.length). On desktop the text slide is keen slide 0,
    // so subtract it from the index and clamp — the text slide reads "1/N", never overflowing to N+1.
    const displayIndex = computed(() => {
        const total = props.elements?.length || 0;
        const offset = showTextSlide.value ? 1 : 0;
        return Math.min(Math.max(current.value + 1 - offset, 1), total);
    });
    onMounted(() => {
        const mq = window.matchMedia('(min-width: 1024px)');
        const apply = () => {
            showTextSlide.value = mq.matches;
            nextTick(() => slider.value?.update());
        };
        apply();
        mq.addEventListener('change', apply);
    });

    const seoUrls = ref({});

    const { getUrlById } = useCategorySeoUrl();

    const getUrl = async (link: string) => {
        try {
            const ids = ref([link]);
            const data = getUrlById(link);
            const url = data[link];
            seoUrls.value[link] = url;
            return url;
        } catch (error) {
            console.error('Error fetching SEO URL:', error);
            return '#';
        }
    };

    const fetchSeoUrls = async () => {
        if (!props.elements) return;

        const promises = props.elements.map(async element => {
            if (element?.link?._ref) {
                await getUrl(element.link._ref);
            }
        });

        await Promise.all(promises);
    };

    // Fetch SEO URLs immediately
    await fetchSeoUrls();

    const serializers = {
        types: {
            button: resolveComponent('Button'),
        },
    };

    const imageSources = [{ width: 250 }, { width: 320 }, { width: 480 }, { width: 640 }, { width: 800 }];
</script>

<style scoped>
    .swiper-button-next::after {
        display: none;
    }
    .gray-arrow {
        filter: grayscale(100%);
    }

    .alt-title {
        /* Remove pre-wrap since we're using HTML breaks now */
        white-space: normal;
    }
</style>
